export enum ProfileSelectorColumnDataTypeEnum {
  String = 0,
  Email = 1,
  Date = 2,
  Boolean = 3,
  SubscriptionStatus = 4,
}
